"use client";

import React, { useContext, useEffect, useState } from "react";
import styles from "./EnrollButton.module.scss";
import cn from "clsx";
import { ModalContext } from "@/context/ModalContext";
import { GA_EVENTS, GAEvent } from "@/helpers/gaEvents";
import { usePathname } from "next/navigation";
import { IModalActions, ModalTypes } from "@/types/modal";
import { getGlobalStateValue } from "@/context/utils";
import { pushToDataLayer } from "@/helpers/gtag";
import popupData from "@/data/popup-data.json";
import ClientSideButton from "@/components/molecules/Carousels/HeroCarousel/ClientSideButton";
import { colors } from "@/helpers/ourJourneySliderHelpers";
import { NONAME } from "dns";

const EnrollButton = ({ data, associatedPrograms, popup = {}, isSponsoredCertificates = false }) => {
  const [isVisible, setIsVisible] = useState(false);
  const { modalDispatch } = useContext(ModalContext);
  const pathName = usePathname();
  const isCertificationsPage = pathName == "/certifications/thank-you" || pathName == "/certifications/payment-failed" || pathName == "/certifications";

  const toggleVisibility = () => {
    if (
      window.location.pathname === "/" ||
      window.location.pathname === "/certifications/thank-you" ||
      window.location.pathname === "/certifications/payment-failed"
    ) {
      if (window.scrollY > 0.7 * window.innerHeight) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    } else {
      setIsVisible(true);
    }
  };

  useEffect(() => {
    if (data?.CTA?.enabled && window.innerWidth < 768) {
      toggleVisibility();
      window.addEventListener("scroll", toggleVisibility);
    }

    if (
      window.location.pathname !== "/" &&
      document.getElementById("new-lead-form")
    ) {
      const currentRef = document.getElementById("enroll-now-cta");
      currentRef.style.display = "none";
    }

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);
  const { LEAD_INITIATE } = GAEvent;

  const excludedPaths = ["/predegree", "/author-list", "/author"];
  const isDynamicAuthorSlug = pathName.startsWith("/author/");

  if (excludedPaths.includes(pathName) || isDynamicAuthorSlug) {
    return null; // Hide the component
  }

  const onClickHandler = () => {
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.ConnectModal,
        modalData: { associatedPrograms, isLandingPage: true, popup },
      },
    });

    setTimeout(() => {
      pushToDataLayer({
        ...GA_EVENTS.get(LEAD_INITIATE),
        cta_text: data?.CTA?.text || "NA",
        section_name: "Mobile Footer",
        header_title: "NA",
        page_type: getGlobalStateValue("pageType"),
        page_url: window.location.href,
      });
    }, 2000);
  };

  return (
    <>
      <div
        id="enroll-now-cta"
        className={cn({ [styles.root]: isVisible })}
      > 
       {pathName != "/predegree" && !isCertificationsPage && !isSponsoredCertificates && (
        <ClientSideButton
          modalType={ModalTypes.ConnectModal}

          GADataNew={{
            ...GA_EVENTS.get(LEAD_INITIATE),
            cta_text: "Enquire Now",
            section_name: "Mobile Footer",
            header_title: "NA",
            isPageType: true,
            page_url: true,
          }}
          webEngageEvents={{
            "Section Name": "Mobile Footer",
            isPageType: true,
          }}
          modalData={{
            associatedPrograms,
            isLandingPage: true,
            popup: popupData,
          }}
          styles={{ backgroundColor: '#1a325d', color: '#fff', border: 'none' }}
          className={cn("scrollbtn scrollButton", styles.enquireNowBtn, {
            [styles.show]: isVisible,
            ["!hidden"]: !isVisible,
          })}
          ctaText={"ENQUIRE NOW"}
          enquiryNow={true}
        />
        )}

    {pathName != "/predegree" && !isCertificationsPage && !isSponsoredCertificates &&(
        <ClientSideButton
          modalType={
            isSponsoredCertificates
              ? ModalTypes.ConnectModalFormSponsoredCourses
              : ModalTypes.ConnectModal
          }
          GADataNew={{
            ...GA_EVENTS.get(LEAD_INITIATE),
            cta_text: "Apply Now",
            section_name: "Mobile Footer",
            header_title: "NA",
            isPageType: true,
            page_url: true,
          }}
          webEngageEvents={{
            "Section Name": "Mobile Footer",
            isPageType: true,
          }}
          modalData={{
            associatedPrograms,
            isLandingPage: true,
            popup: popupData,
          }}
          ctaText={isSponsoredCertificates ? "ENROLL NOW" : "APPLY NOW"}
          styles={{border: 'none' }}
          className={cn("scrollbtn scrollButton", styles.scrollButton, {[styles.show]: isVisible,["!hidden"]: !isVisible,})}
        />
        )}
      </div>
    </>
  );
};

export default EnrollButton;
